var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('p',{staticClass:"text-section-wrapper body-intro"},[_vm._v("\n  "+_vm._s(_vm.content)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }